import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as _ from 'lodash';
import * as moment from 'moment';

import { MonthViewModel } from '../../viewModels/month-viewmodel';
import { SelectedDay } from '../../viewModels/selectedDay-viewmodel';

@Component({
  selector: 'app-day-selector',
  templateUrl: './day-selector.component.html',
  styleUrls: ['./day-selector.component.scss']
})
export class DaySelectorComponent implements OnInit {
  @Input() public dates: SelectedDay[];
  @Input() public currentDay: Date;
  @Input() public unlimited: boolean;

  @Output() public onClose: EventEmitter<boolean>;

  private availableDates: SelectedDay[];
  private selectAll: boolean;

  private readonly maxItemsAllowed = 5;
  public maxPossibleItems: number;
  public itemsSelected: number;
  public months: MonthViewModel[];

  constructor() {
    this.onClose = new EventEmitter<boolean>();
    this.availableDates = [];
    this.months = [];
  }

  ngOnInit(): void {
    this.selectAll = false;
    this.availableDates = _.cloneDeep(this.dates);
    this.initializeMonths();
    this.maxPossibleItems = !this.unlimited && this.availableDates.length > this.maxItemsAllowed ? this.maxItemsAllowed : this.availableDates.length;
    this.setItemsSelected();
  }

  private initializeMonths(): void {
    for (let i = 0; i < 12; i++) {
      const daysInMonth = _.filter(this.availableDates, (date: SelectedDay) => {
        return date.date.getMonth() === i;
      });

      this.months.push({
        index: i,
        name: moment().month(i).format('MMMM').toUpperCase(),
        selected: _.some(daysInMonth, (day: SelectedDay) => {
          return day.selected || this.currentDay.getMonth() === i;
        }),
        disabled: daysInMonth.length === 0
      });
    }
  }

  private getSelectedMonths(): MonthViewModel[] {
    return _.filter(this.months, (month: MonthViewModel) => {
      return month.selected;
    });
  }

  setItemsSelected(): void {
    this.itemsSelected = _.filter(this.availableDates, (day: SelectedDay) => day.selected).length;
  }

  isDisabled(day: SelectedDay): boolean {
    return !this.unlimited && (this.isCurrentDay(day.date) || (!day.selected && this.itemsSelected >= this.maxItemsAllowed));
  }

  noItemsSelected(): boolean {
    if (!this.hasAvailableDates()) {
      return true;
    }
    if (this.unlimited) {
      return this.itemsSelected === 0;
    }
    return this.itemsSelected === 1;
  }

  getAvailableDates(): SelectedDay[] {
    const selectedMonths: MonthViewModel[] = this.getSelectedMonths();

    return _.filter(this.availableDates, (day: SelectedDay) => {
      return (_.some(selectedMonths, (month: MonthViewModel) => {
        return day.date.getMonth() === month.index;
      }) || !this.isUnlimited && this.isCurrentDay(day.date));
    });
  }

  getDayName(date: Date): string {
    return moment(date).format('dddd').toUpperCase();
  }

  hasAvailableDates(): boolean {
    return this.availableDates.length > 0;
  }

  isCurrentDay(date: Date): boolean {
    if (this.currentDay) {
      return this.currentDay.getTime() === date.getTime();
    } else {
      return false;
    }
  }

  isUnlimited(): boolean {
    return this.unlimited;
  }

  selectAllChanged(): void {
    _.each(this.availableDates, (date: SelectedDay) => {
      date.selected = this.selectAll;
    });
    this.setItemsSelected();
  }

  getMonths(): MonthViewModel[] {
    return this.months;
  }

  toggleMonth(month: MonthViewModel): void {
    if (!month.selected || this.getSelectedMonths().length > 1) {
      month.selected = !month.selected;
    }
  }

  apply(): void {
    _.each(this.availableDates, (dateSelection: SelectedDay) => {
      let date = _.find(this.dates, d => d.date.getTime() === dateSelection.date.getTime());
      if (date) {
        date.selected = dateSelection.selected;
      }
    });

    this.onClose.emit(true);
  }

  cancel(): void {
    this.onClose.emit(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/route-detail/components/day-selector/day-selector.component.ts